import React, { useEffect, useState } from "react";
import { MessageSquareWarning } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/i18n";

/** Meldingen die medewerkers bij het afmelden achterlieten (laatste 2 dagen). */
export default function ShiftNotes() {
  const { t } = useLang();
  const [notes, setNotes] = useState([]);
  useEffect(() => { api.get("/timesheets/notes?days=2").then(({ data }) => setNotes(data)).catch(() => {}); }, []);
  if (notes.length === 0) return null;
  return (
    <div className="mb-4 rounded-xl border border-amber-200 dark:border-amber-900 bg-amber-50/70 dark:bg-amber-950/30 p-4" data-testid="shift-notes">
      <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.18em] text-amber-700 dark:text-amber-300">
        <MessageSquareWarning className="h-4 w-4" />{t("shift_notes_title")}
      </p>
      <ul className="mt-2 space-y-1.5">
        {notes.slice(0, 6).map((n, i) => (
          <li key={`${n.end}-${i}`} className="text-sm text-foreground/90" data-testid={`shift-note-${i}`}>
            <span className="font-semibold">{n.user_name}</span>
            <span className="text-xs text-muted-foreground"> · {n.date} {(n.end || "").slice(11, 16)}
              {n.reason === "break" ? ` · ${t("break")}` : ""}</span>
            <span className="block">{n.note}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
